var supportedSponsoredFacets = ["f[category_correlated]", "f[trending_brand]", "f[price_range:min]", "f[price_range:max]", "f[rating_categories]", "f[delivery]", "f[seller_type]"];
export function hasUnsupportedSponsoredFacets(queryObject) {
  return Object.keys(queryObject).some(function (key) {
    var isFacet = key.startsWith("f[");
    return isFacet && !supportedSponsoredFacets.includes(key);
  });
}